import { Component, OnInit, OnDestroy } from "@angular/core";
import { ToastrManager } from "ng6-toastr-notifications";
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { CoreService } from "../../Services/core.service";
import { SharedService } from "src/app/shared/Services/shared.service";
import { Constant } from "src/app/shared/Constants/constant";
import { ValidationService } from "src/app/shared/Services/validation.service";
import { TitleService } from 'src/app/shared/Services/title.service';
import { LoaderService } from "src/app/shared/Services/loader.service";
import { LayoutService } from "src/app/shared/Services/layout.service";
import { BaseComponent } from "src/app/shared/Components/base/base.component";
import { LoggingService } from "src/app/shared/Services/NGLogger/logging-service.service";
import { Subject, catchError, firstValueFrom, of, takeUntil, tap } from "rxjs";

@Component({
  selector: "app-sign-up",
  templateUrl: "./sign-up.component.html",
  styleUrls: ["./sign-up.component.css"],
})
export class SignUpComponent extends BaseComponent implements OnInit, OnDestroy {
  HeadingText: any;
  newForm!: FormGroup<any>;
  CurrentItem: any;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    super();
  }

  override ngOnInit() {
  }

}
